export default __webpack_public_path__ + "static/hero-17f8dc0ef745ca79bcccebaa83ecf073.jpg";